import api from '../../lib/api';
import { url_api_v1_project_folders_get,  url_api_v1_projects_search_get } from '../../lib/apiUrl';

class ProjectService {
  getProjects = async (filters:string) => {
    try {
      let url = url_api_v1_projects_search_get + filters;
      const response = await api.get(url);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error while fetching projects.');
      }
      if ('projects' in response.data) {
        const { projects } = response.data;
        return projects;
      }
      return [];
    } catch (error) {
      throw error;
    }
  };
  fetchProjectFolders = async (project_uuid: string, filter:string) => {
    try {
      let url = url_api_v1_project_folders_get.replace(':project_uuid', project_uuid);
      const response = await api.get(url + '?'+ filter);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error while fetching folders.');
      }
      if ('scene_cards' in response.data) {
        return response.data;
      }
      return [];
    } catch (error) {
      throw error;
    }
  };
  // fetchProjectSceneCards = async (project_uuid: string) => {
  //   try {
  //     let url = url_api_v1_project_scenecard_get.replace(':project_uuid', project_uuid);
  //     const response = await api.get(url);
  //     if (response.status !== 200 && response.status !== 201) {
  //       throw new Error('Error while fetching scene cards.');
  //     }
  //     if ('scene_cards' in response.data) {
  //       const { scene_cards } = response.data;
  //       return scene_cards;
  //     }
  //     return [];
  //   } catch (error) {
  //     throw error;
  //   }
  // };
}

const projectService = new ProjectService();

export default projectService;
